export const CLIENT_STATUSES = {
  PROGRESS: 'progress',
  UNIQUE: 'unique',
  SAME_PINNED: 'same_pinned',
  PINNED: 'pinned',
};

export const PROJECT_STATUSES = {
  FUTURE: 'future',
  CURRENT: 'current',
};

export enum ConsultationType {
  offline = 'offline_meet',
  online = 'online_consultation',
}

export const PropertyStatus = {
  0: 'Свободен',
  1: 'Продана',
  2: 'Забронирована',
  3: 'Не для продажи',
  4: 'Скоро в продаже',
} as { [key: number]: string };
